import { apiSlice } from "../../Api/apiSlice";

const coursePlayerApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get Assignment
    getAssignmentWithVideoId: builder.query({
      query: (vid) => `/assignments?video_id_like=${vid}`,
    }),
    // Get AssignmentMark which student already give repo link
    getAssignmentMarkStudent: builder.query({
      query: ({ sId, agnId }) =>
        `/assignmentMark?student_id_like=${sId}&assignment_id_like=${agnId}`,
    }),
    // Set Assignment repo and others
    addAssignmentRepo: builder.mutation({
      query: (data) => ({
        url: `/assignmentMark`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetAssignmentWithVideoIdQuery,
  useAddAssignmentRepoMutation,
  useGetAssignmentMarkStudentQuery,
} = coursePlayerApi;
